import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../../../../utils/date-utils';

@Pipe({
  name: 'dateStringWithAt'
})
export class DateStringWithAtPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(date: string | null): string {
    if (!date) return '';
    const dateObj = new Date(date);
    const formattedDate = new Intl.DateTimeFormat(this.locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(dateObj);

    const formattedTime = new Intl.DateTimeFormat(this.locale, {
      hour: 'numeric',
      minute: 'numeric'
    }).format(dateObj);

    const localizedAt = $localize`:separator between date and time:at`;
    const timeZone = DateUtils.localTimeZoneAbbreviation(dateObj);
    return `${formattedDate} ${localizedAt} ${formattedTime} ${timeZone}`;
  }
}
